// extracted by mini-css-extract-plugin
export default {"addVacations":"VacLessDay_addVacations__Zxkg0","customFileUpload":"VacLessDay_customFileUpload__lYT2e"};